import { useCallback, useRef, useState } from "react";
import { clampProgress } from "./clamp-progress";

export function useScrollbarProgress() {
  const [scrollProgress, setScrollbarProgress] = useState(0);

  const updateScrollProgress = useCallback((element: HTMLDivElement | null) => {
    if (!element) {
      return;
    }

    const { scrollWidth, clientWidth, scrollLeft } = element;

    const progress = scrollLeft / (scrollWidth - clientWidth);

    // TODO: Reposition carousel so that selected element is always visible

    setScrollbarProgress(clampProgress(progress));
  }, []);

  return [scrollProgress, updateScrollProgress] as const;
}
